import { useAuthStore } from '@/state/authStore';
import { USER_ROLE_LABELS } from '@/types/user';

export function AppHeader() {
  const user = useAuthStore((s) => s.currentUser);
  const clear = useAuthStore((s) => s.clear);

  const handleLogout = () => {
    clear();
    window.location.href = '/auth/logout';
  };

  const roleLabel = user ? USER_ROLE_LABELS[user.role] : '';

  return (
    <header className="flex h-14 items-center justify-between gap-4 border-b border-gray-200 bg-white px-4 sm:px-6">
      <h1 className="min-w-0 flex-1 truncate text-base font-semibold text-gray-800 sm:text-lg">
        Delphi　AI Coach Feedback System
      </h1>
      <div className="flex min-w-0 shrink-0 items-center gap-3">
        {user && (
          <>
            <span className="hidden min-w-0 max-w-[12rem] truncate text-sm text-gray-700 sm:inline">
              {user.name}
              <span className="ml-2 rounded bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
                {roleLabel}
              </span>
            </span>
            <button
              type="button"
              onClick={handleLogout}
              className="rounded border border-gray-300 px-3 py-1 text-sm text-gray-700 hover:bg-gray-50"
            >
              ログアウト
            </button>
          </>
        )}
      </div>
    </header>
  );
}
